import * as types from 'modulesV2/constants';

function rosterSyncReducer(state = {}, action) {
  switch (action.type) {
    case types.REQUEST_DISTRICT_CONFIGURATION:
      return {
        ...state,
        error: null,
        isLoading: true,
      };
    case types.REQUEST_DISTRICT_CONFIGURATION_SUCCESS:
      return {
        ...state,
        error: null,
        isLoading: false,
        data: action.data,
      };
    case types.REQUEST_DISTRICT_CONFIGURATION_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };
    default:
      return state;
  }
}

export default rosterSyncReducer;
